import rules from "./password_rules.json";

export function validatePassword(
  password,
  { username, firstName, lastName, badgeNumber } = {}
) {
  const fields = { username, firstName, lastName, badgeNumber };
  const errors = [];

  rules.rules.forEach(rule => {
    switch (rule.type) {
      case "length":
        if (password.length < rule.minLength) {
          errors.push(rule.errorMessage);
        }
        break;

      case "regex": {
        const regex = new RegExp(rule.pattern);
        if (!regex.test(password) && password.length > 0) {
          errors.push(rule.errorMessage);
        }
        break;
      }

      case "contains": {
        const field = fields[rule.field];
        if (field) {
          const containsField = password
            .toLowerCase()
            .includes(field.toLowerCase());
          if (containsField === rule.invert) {
            errors.push(rule.errorMessage);
          }
        }
        break;
      }

      default:
        break;
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
}
